export default __webpack_public_path__ + "static/media/admin.a2e01245.png";